import React from "react";
import { motion } from "framer-motion";
import { PROFILE, EXPERTISE, PLAYING } from "@/data/content";

const reveal = {
  hidden: { opacity: 0, y: 40 },
  show: { opacity: 1, y: 0, transition: { duration: 0.6, ease: [0.22, 1, 0.36, 1] } },
};

export default function About() {
  return (
    <section id="about" className="relative py-24 md:py-32 bg-[#050505]" data-testid="about-section">
      <div className="container mx-auto px-6 md:px-12">
        <motion.div
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, margin: "-80px" }}
          variants={reveal}
          className="flex items-center gap-3 mb-14"
        >
          <span className="font-mono text-xs tracking-[0.25em] uppercase text-volt">01 / About</span>
          <span className="h-px flex-1 bg-neutral-800" />
        </motion.div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 md:gap-12 items-start">
          {/* Portrait */}
          <motion.div
            initial="hidden"
            whileInView="show"
            viewport={{ once: true }}
            variants={reveal}
            className="lg:col-span-5 relative"
          >
            <div className="relative aspect-[4/5] overflow-hidden border border-neutral-800">
              <img
                src={PROFILE.photos.portrait}
                alt="Kusum Shaikh, football coach"
                loading="eager"
                className="w-full h-full object-cover object-bottom transition-transform duration-700 hover:scale-105"
                data-testid="about-portrait"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#050505] via-transparent to-transparent" />
            </div>
            <div className="absolute -bottom-5 -left-2 bg-volt text-black px-5 py-3 font-heading text-sm tracking-wide">
              {PROFILE.fullName}
            </div>
          </motion.div>

          {/* Text */}
          <motion.div
            initial="hidden"
            whileInView="show"
            viewport={{ once: true }}
            variants={reveal}
            className="lg:col-span-7"
          >
            <h2 className="font-heading uppercase text-4xl sm:text-5xl lg:text-6xl leading-[0.9] tracking-tight text-white">
              Breaking barriers,
              <br />
              <span className="text-volt">building winners.</span>
            </h2>
            <p className="mt-8 font-body font-light text-base md:text-lg leading-relaxed text-neutral-300 max-w-2xl">
              {PROFILE.summary}
            </p>

            {/* Playing background chips */}
            <div className="mt-8">
              <p className="font-mono text-xs uppercase tracking-[0.2em] text-neutral-500 mb-3">
                Playing Background
              </p>
              <div className="flex flex-wrap gap-2">
                {PLAYING.map((p) => (
                  <span
                    key={p}
                    className="font-mono text-xs uppercase tracking-wide border border-neutral-800 px-3 py-2 text-neutral-300"
                    data-testid={`playing-chip-${p.replace(/\s+/g, "-").toLowerCase()}`}
                  >
                    {p}
                  </span>
                ))}
              </div>
            </div>

            {/* Expertise grid */}
            <div className="mt-8 grid grid-cols-2 gap-x-6 gap-y-3">
              {EXPERTISE.map((skill, i) => (
                <div key={skill} className="flex items-center gap-3 border-b border-neutral-900 py-2">
                  <span className="font-mono text-[10px] text-volt">{String(i + 1).padStart(2, "0")}</span>
                  <span className="font-body text-sm text-neutral-200">{skill}</span>
                </div>
              ))}
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
